<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header">
      <span
        class="btn"
        (click)="dismiss()"
        style="float: right; color: #fff"
        class="material-symbols-outlined"
        >close</span
      >
      ANDAR BAHAR 2 - Result
    </div>
    <div class="card-body p-1 pb-4">
      <div>
        <div class="casino-result-round">
          <div>Round-Id: {{ data.mid }}</div>
          <div>
            Match Time:
            <span>{{
              filter_bets.length > 0
                ? (filter_bets[0].updated_at | date : "dd/MM/y H:mm:ss")
                : data?.stored_data?.updated_at
                ? (data.stored_data.updated_at | date : "dd/MM/y H:mm:ss")
                : ""
            }}</span>
          </div>
        </div>
        <div class="">
          <div class="">
            <div class="row row5">
              <div class="col-1 abj-title">
                <div class="row row5">
                  <div class="col-12"><b>A</b></div>
                </div>
                <div class="row row5">
                  <div class="col-12"><b>B</b></div>
                </div>
              </div>
              <div class="col-2 abj-common-card">
                <div class="casino-result-cards-item">
                  <img
                    src="/assets/casino/cards/{{ first_3_cards[0] + '.png' }}"
                  />
                </div>
              </div>
              <div class="col-9">
                <div class="card-inner">
                  <div class="row row5">
                    <div class="col-3">
                      <div class="casino-result-cards-item">
                        <img
                          src="/assets/casino/cards/{{
                            first_3_cards[2] + '.png'
                          }}"
                        />
                      </div>
                    </div>
                    <div class="col-7">
                      <section tabindex="0" class="lastCards-result hooper">
                        <div class="hooper-list">
                          <ul
                            [ngStyle]="{
                              transform: 'translateX(' + position_andar + 'px)'
                            }"
                            class="hooper-track"
                            style="transform: translate(0px)"
                          >
                            <li
                              *ngFor="let player of array1"
                              class="hooper-slide is-active is-current"
                              style="width: 64.5583px"
                            >
                              <div class="casino-result-cards-item">
                                <img
                                  src="/assets/casino/cards/{{
                                    player + '.png'
                                  }}"
                                />
                              </div>
                            </li>
                          </ul>
                          <div class="hooper-navigation">
                            <button
                              type="button"
                              (click)="translateRight('andar')"
                              class="hooper-prev"
                            >
                              <svg
                                class="icon icon-arrowLeft"
                                viewBox="0 0 24 24"
                                width="24px"
                                height="24px"
                              >
                                <title>Arrow Left</title>
                                <path d="M0 0h24v24H0z" fill="none"></path>
                                <path
                                  d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                                ></path>
                              </svg></button
                            ><button
                              type="button"
                              (click)="translateLeft('andar')"
                              class="hooper-next"
                            >
                              <svg
                                class="icon icon-arrowRight"
                                viewBox="0 0 24 24"
                                width="24px"
                                height="24px"
                              >
                                <title>Arrow Right</title>
                                <path d="M0 0h24v24H0z" fill="none"></path>
                                <path
                                  d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                                ></path>
                              </svg>
                            </button>
                          </div>
                          <div
                            aria-live="polite"
                            aria-atomic="true"
                            class="hooper-liveregion hooper-sr-only"
                          >
                            Item 1 of 3
                          </div>
                        </div>
                      </section>
                    </div>
                    <div class="col-2 m-0 p-0" *ngIf="win == 1">
                      <div class="casino-result-cards-item">
                        <img
                          src="https://wver.sprintstaticdata.com/v89/static/front/img/winner.png"
                          class="winner-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-inner">
                  <div class="row row5">
                    <div class="col-3">
                      <div class="casino-result-cards-item">
                        <img
                          src="/assets/casino/cards/{{
                            first_3_cards[1] + '.png'
                          }}"
                        />
                      </div>
                    </div>
                    <div class="col-7">
                      <section tabindex="0" class="lastCards-result hooper">
                        <div class="hooper-list">
                          <ul
                            [ngStyle]="{
                              transform: 'translateX(' + position_bahar + 'px)'
                            }"
                            class="hooper-track"
                            style="transform: translate(0px)"
                          >
                            <li
                              *ngFor="let player of array2"
                              class="hooper-slide is-active is-current"
                              style="width: 64.5583px"
                            >
                              <div class="casino-result-cards-item">
                                <img
                                  src="/assets/casino/cards/{{
                                    player + '.png'
                                  }}"
                                />
                              </div>
                            </li>
                          </ul>
                          <div class="hooper-navigation">
                            <button
                              type="button"
                              (click)="translateRight('bahar')"
                              [disabled]="position_bahar >= 0"
                              class="hooper-prev"
                            >
                              <svg
                                class="icon icon-arrowLeft"
                                viewBox="0 0 24 24"
                                width="24px"
                                height="24px"
                              >
                                <title>Arrow Left</title>
                                <path d="M0 0h24v24H0z" fill="none"></path>
                                <path
                                  d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                                ></path>
                              </svg></button
                            ><button
                              type="button"
                              (click)="translateLeft('bahar')"
                              [disabled]="position_bahar <= -900"
                              class="hooper-next"
                            >
                              <svg
                                class="icon icon-arrowRight"
                                viewBox="0 0 24 24"
                                width="24px"
                                height="24px"
                              >
                                <title>Arrow Right</title>
                                <path d="M0 0h24v24H0z" fill="none"></path>
                                <path
                                  d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                                ></path>
                              </svg>
                            </button>
                          </div>
                          <div
                            aria-live="polite"
                            aria-atomic="true"
                            class="hooper-liveregion hooper-sr-only"
                          >
                            Item 1 of 4
                          </div>
                        </div>
                      </section>
                    </div>
                    <div class="col-2 m-0 p-0" *ngIf="win == 2">
                      <div class="casino-result-cards-item">
                        <img
                          src="https://wver.sprintstaticdata.com/v89/static/front/img/winner.png"
                          class="winner-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-5 m-0 p-0">
              <div class="casino-result-desc">
                <div class="casino-result-desc-item">
                  <div>
                    Winner
                    <span style="color: #eee">{{
                      win == "1" ? "Andar" : "Bahar"
                    }}</span>
                  </div>
                </div>
                <div class="casino-result-desc-item">
                  <div>
                    Suit <span style="color: #eee">{{ joker_win }} </span>
                  </div>
                </div>
                <div class="casino-result-desc-item">
                  <div>
                    Odd/Even
                    <span style="color: #eee">
                      {{ joker_oddeven_win }}
                    </span>
                  </div>
                </div>
                <div class="casino-result-desc-item">
                  <div>
                    Joker<span style="color: #eee">
                      {{ joker_num_win }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="3 > 6" class="col-12 col-lg-12">
              <div class="casino-result-cards">
                <div class="d-inline-block">
                  <h4 class="text-center">Andar</h4>
                  <div
                    *ngFor="let player of player1"
                    class="casino-result-cards-item"
                  >
                    <img src="/assets/casino/cards/{{ player + '.png' }}" />
                  </div>
                </div>
                <div class="d-inline-block">
                  <h4 class="text-center">Bahar</h4>
                  <div
                    *ngFor="let player of player2"
                    class="casino-result-cards-item"
                  >
                    <img src="/assets/casino/cards/{{ player + '.png' }}" />
                  </div>
                </div>
              </div>
            </div> -->
        </div>
      </div>
      <!--    //filters-->

      <div class="mt-2" *ngIf="casino_bets.length > 0">
        <div class="d-flex flex-column justify-content-between">
          <div>
            <span>
              <input
                type="radio"
                name="filter_type"
                value="all"
                id="filter_all"
                (input)="filterBetsByType($event)"
                checked
              />
              <label for="filter_all">All</label>
            </span>
            <span>
              <input
                type="radio"
                name="filter_type"
                value="Back"
                id="filter_back"
                (input)="filterBetsByType($event)"
              />
              <label for="filter_back">Back</label>
            </span>
            <span>
              <input
                type="radio"
                name="filter_type"
                value="Lay"
                id="filter_lay"
                (input)="filterBetsByType($event)"
              />
              <label for="filter_lay">Lay</label>
            </span>
            <span>
              <input
                type="radio"
                name="filter_type"
                value="deleted"
                id="filter_deleted"
                (input)="filterBetsByType($event)"
              />
              <label for="filter_deleted">Deleted</label>
            </span>
          </div>
          <div class="d-block mt-2">
            Total bets:
            <span [class.text-success]="totalbets > 0">{{ totalbets }}</span>
            &nbsp; Total Amount:
            <span
              [class.text-success]="totalAmount > 0"
              [class.text-danger]="totalAmount < 0"
              >{{ totalAmount }}</span
            >
          </div>
        </div>
      </div>
      <!--        filtered data-->
      <div class="w-100 overflow-auto mt-2" *ngIf="filter_bets.length > 0">
        <table class="table table-sm table-hover table-green">
          <thead>
            <tr>
              <th>Nation</th>
              <th class="text-right">Rate</th>
              <th class="">Amount</th>
              <th class="">Win</th>
              <th class="">Date</th>
            </tr>
          </thead>
          <tbody *ngIf="filter_bets.length > 0; else nodata">
            <tr
              *ngFor="let data of filter_bets; index as i"
              [class.lay-border]="data.type == 'Lay'"
              [class.back-border]="data.type == 'Back'"
            >
              <td>{{ data.runner_name }}</td>
              <td class="text-right">{{ data.odds }}</td>
              <td class="text-right">{{ data.bet_amount }}</td>
              <td class="text-right">{{ data.profit_loss }}</td>
              <td>
                {{ data.created_at | date : "dd/MM/Y H:mm:ss" }} (UTC+05:30)
              </td>
            </tr>
          </tbody>
          <ng-template #nodata>
            <tbody>
              <tr>
                <td>no data found</td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </div>
  </div>
</div>
